export default "__VITE_ASSET__CtJ9BAqB__"